import {useEffect,useState} from 'react';
import {Navigate,Link} from 'react-router-dom';
import {useAuth} from '../Maindashboard/Context/AuthContext';
import DashboardLayout from '../Maindashboard/Layouts/DashboardLayout';
import VendorLayout from '../Vendordashboard/Layouts/DashboardLayout';
import GuideCenter from './GuideCenter';

export function ERPGuide(){
 const auth=useAuth();
 if(auth.loading)return <p className="p-6">Checking access…</p>;
 if(!auth.user)return <Navigate to="/stafflogin" replace/>;
 return <DashboardLayout><GuideCenter auth={auth}/></DashboardLayout>;
}
const API=process.env.REACT_APP_API_URL||(['localhost','127.0.0.1'].includes(window.location.hostname)?'/api':'/api');
function PortalGuide({portal}){
 const [state,setState]=useState({loading:true}),[retry,setRetry]=useState(0);
 useEffect(()=>{const controller=new AbortController();setState({loading:true});fetch(API+(portal==='vendor'?'/vendor/me':'/billing/me'),{credentials:'include',signal:controller.signal}).then(async r=>{
  if(r.status===401||r.status===403){setState({denied:true});return;}
  const data=await r.json();if(!r.ok)throw Error('The guide could not verify your session.');
  if(data.status!=='success'){setState({denied:true});return;}
  const user=portal==='vendor'?data.vendor:data.user;
  if(!user)throw Error('Account identity was not returned.');
  if(portal==='billing'&&user.role!=='super_admin'&&!(user.permissions||[]).includes('pos.view')){setState({denied:true});return;}
  setState({user,permissions:user.permissions||[]});
 }).catch(e=>{if(e.name!=='AbortError')setState({error:e.message});});return()=>controller.abort();},[portal,retry]);
 if(state.loading)return <p className="p-6">Checking portal access…</p>;
 if(state.denied)return <Navigate to={portal==='vendor'?'/vendorlogin':'/billinglogin'} replace/>;
 if(state.error)return <div className="p-6"><p role="alert">{state.error}</p><button className="mt-4 rounded-xl border p-3" onClick={()=>setRetry(retry+1)}>Try again</button></div>;
 const content=<GuideCenter auth={state} portal={portal}/>;
 if(portal==='vendor')return <VendorLayout>{content}</VendorLayout>;
 return <main className="erp-ui min-h-screen bg-[#07070b] p-4 text-white md:p-8"><div className="mx-auto max-w-7xl"><Link to="/billingdashboard" className="mb-5 inline-block rounded-xl border border-white/15 px-4 py-2 text-amber-200">← Return to billing</Link><p className="mb-3 text-xs text-gray-400">Reading help does not complete, cancel or clear your current bill. Return to the original billing tab to preserve an unsaved draft.</p>{content}</div></main>;
}
export const VendorGuide=()=> <PortalGuide portal="vendor"/>;
export const BillingGuide=()=> <PortalGuide portal="billing"/>;
